import type { ReactNode } from "react";

import { FilterDefinitionType } from "@/components/@types";
import { Icon } from "@/components/atoms/Icon";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/components/ui/utils";

export function FilterDefinitionRow({
  filterDefinition,
  isCompact = false,
  trailing,
}: {
  filterDefinition: Pick<FilterDefinitionType, "name" | "type" | "ReactIcon">;
  /** A narrow row, for a list that opens beside another. */
  isCompact?: boolean;
  /** In place of the filter's type, at the row's end. */
  trailing?: ReactNode;
}) {
  return (
    <div
      data-testid={`filter-definition-row-${filterDefinition.name}`}
      className={cn(
        "flex min-w-0 flex-wrap",
        "items-center gap-2 pl-1",
        isCompact ? "min-w-60" : "min-w-100",
      )}
    >
      <div>
        {
          <Icon
            ReactIcon={filterDefinition.ReactIcon}
            size="sm"
            style={{
              transform: "translateY(1px)",
            }}
          />
        }
      </div>
      <Typography level="body-md">{filterDefinition.name}</Typography>
      <div className="grow" />
      {trailing ?? (
        <Typography
          level="body-xs"
          className="[border-width:1px] [border-style:solid] border-border text-muted-foreground/80 pl-1 pr-1 pb-px text-center rounded"
        >
          {filterDefinition.type}
        </Typography>
      )}
    </div>
  );
}
